<script>export let title;
export let description = "";
</script>

<div class="page-heading">
	<h1>{@html title}</h1>

	{#if description}
		<p>{@html description}</p>
	{/if}
</div>

<style>.page-heading{color:hsla(var(--hsl-black));display:grid;grid-gap:.375rem;gap:.375rem}h1{font:var(--f-heading-lg-semibold)}p{font:var(--f-paragraph-sm-regular)}</style>
